import { type MerchantConfig, ThirdPartySystemId } from '@pillar-portal/api-types';
import { resolveIpgCredentialDefaultsBySystemId } from './ipg/credential-defaults-registry';

export type DefaultableCredentialField = 'domain' | 'channel';

export type CredentialFieldDefaults = Readonly<Partial<Record<DefaultableCredentialField, string>>>;

export function resolveCredentialDefaultsBySystemId(
    systemId: ThirdPartySystemId,
    merchantConfig: MerchantConfig | undefined
): CredentialFieldDefaults {
    return resolveIpgCredentialDefaultsBySystemId(systemId, merchantConfig);
}
